// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%27-4 -4 8 8%27%3e%3ccircle r=%273%27 fill=%27rgba%280,0,0,.25%29%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%27-4 -4 8 8%27%3e%3ccircle r=%273%27 fill=%27rgba%28255,255,255,1.0%29%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Bebas+Neue&family=Inter:wght@400;500;600;700&family=Oswald:wght@400;500;600;700&display=swap);"]);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Enhanced Typography */

.App {
  text-align: center;
}

.App-logo {
  height: 40vmin;
  pointer-events: none;
}

@media (prefers-reduced-motion: no-preference) {
  .App-logo {
    animation: App-logo-spin infinite 20s linear;
  }
}

.App-header {
  background-color: #282c34;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  font-size: calc(10px + 2vmin);
  color: white;
}

.App-link {
  color: #61dafb;
}

@keyframes App-logo-spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}

body, .table, .text-start {
  font-family: 'Inter', -apple-system, BlinkMacSystemFont, sans-serif;
  font-feature-settings: 'tnum'; /* Tabular numbers for odds */
}

/* Enhanced Color Variables */
:root {
  --primary-green: #059669;
  --primary-green-dark: #047857;
  --secondary-yellow: #F59E0B;
  --secondary-yellow-dark: #D97706;
  --tertiary-orange: #F97316;
  --tertiary-orange-dark: #EA580C;
  --danger-red: #EF4444;
  --danger-red-dark: #DC2626;
  --gray-50: #F9FAFB;
  --gray-100: #F3F4F6;
  --gray-600: #4B5563;
  --gray-900: #111827;
  --text-gold: #FBBF24;
}

/* Enhanced Table Styling */
.table-container {
  border-radius: 4px;
  overflow: hidden;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
  margin-bottom: 8px;
  display: flex;
  flex-direction: column;
}

/* Mobile matchups spacing adjustments */
.mobile-matchups-table {
  margin-bottom: 0 !important;
}

/* Fix empty table height */
.mobile-matchups-table table {
  min-height: unset !important;
  height: auto !important;
}

.mobile-matchups-table tbody {
  min-height: unset !important;
  height: auto !important;
}

.mobile-matchups-table tbody tr:only-child td {
  padding: 8px !important;
}

/* Pitcher row styling - force background color */
.pitcher-row,
.pitcher-row:hover {
  background-color: rgb(26,26,26) !important;
}

.pitcher-row td,
.pitcher-row:hover td {
  background-color: rgb(26,26,26);
  /*color: white !important;*/
}
.pitcher-row td:first-child, .pitcher-row th:first-child {
  color: yellow !important;
}

.table {
  margin-bottom: 0;
  flex: 1 1;
  display: table;
  width: 100%;
}

.table tbody tr {
  transition: background-color 0.15s ease;
  height: 32px;
  line-height: 1;
}

.table thead tr {
  height: 30px;
  line-height: 1;
}

.table tbody tr:hover {
  background-color: rgba(59, 130, 246, 0.05);
}

.table th {
  background: linear-gradient(135deg, var(--gray-50) 0%, var(--gray-100) 100%);
  font-weight: 600;
  font-size: 0.875rem;
  letter-spacing: 0.025em;
  text-transform: uppercase;
  color: #374151;
  border-bottom: 2px solid #E5E7EB;
  vertical-align: middle;
  height: 30px;
  padding: 4px 8px;
  line-height: 1;
}

.table td {
  vertical-align: middle;
  height: 32px;
  padding: 4px 8px;
  line-height: 1;
}

/* Player name cell with team logo */
.player-name-cell {
  background-size: 16px 16px !important;
  background-repeat: no-repeat !important;
  background-position: 6px center !important;
  padding-left: 28px !important;
  padding-right: 8px !important;
  text-align: left !important;
  vertical-align: middle !important;
  height: 32px !important;
  line-height: 1 !important;
  white-space: nowrap !important;
  overflow: hidden !important;
  text-overflow: ellipsis !important;
}

.player-name-cell-no-logo {
  padding-left: 8px !important;
  padding-right: 8px !important;
  text-align: left !important;
  vertical-align: middle !important;
  height: 32px !important;
  line-height: 1 !important;
  white-space: nowrap !important;
  overflow: hidden !important;
  text-overflow: ellipsis !important;
}

/* Enhanced Odds Cell Styling */
.odds-cell {
  transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);
}

/* Force toggle switch styling */
.form-check-input[type="checkbox"][role="switch"] {
  width: 2em !important;
  margin-left: 0 !important;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) !important;
  background-position: left center !important;
  background-size: contain !important;
  background-repeat: no-repeat !important;
  background-color: #6c757d !important;
  border: 1px solid rgba(0, 0, 0, 0.25) !important;
  border-radius: 2em !important;
  transition: background-position 0.15s ease-in-out !important;
}

.form-check-input[type="checkbox"][role="switch"]:checked {
  background-position: right center !important;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) !important;
  background-color: #0d6efd !important;
  border-color: #0d6efd !important;
}

.form-check-input[type="checkbox"][role="switch"]:focus {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) !important;
  background-color: #6c757d !important;
  border-color: rgba(0, 0, 0, 0.25) !important;
  box-shadow: 0 0 0 0.25rem rgba(13, 110, 253, 0.25) !important;
}

.form-check-input[type="checkbox"][role="switch"]:checked:focus {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) !important;
  background-color: #0d6efd !important;
  border-color: #0d6efd !important;
}

.odds-cell:hover {
  transform: scale(1.05);
  z-index: 10;
  position: relative;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
}

/* Enhanced Live Badge with Glow */
.live-badge {
  background: linear-gradient(135deg, var(--danger-red) 0%, var(--danger-red-dark) 100%) !important;
  box-shadow: 0 0 10px rgba(239, 68, 68, 0.3);
  animation: pulse-glow 2s infinite;
  border: none !important;
  font-weight: 600;
  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.3);
}

/* Countdown Badge */
.countdown-badge {
  background: linear-gradient(135deg, var(--secondary-yellow) 0%, var(--secondary-yellow-dark) 100%) !important;
  color: white !important;
  border: none !important;
  font-weight: 600;
  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.3);
  animation: pulse-countdown 1s infinite;
}

/* Delayed Badge */
.delayed-badge {
  background: linear-gradient(135deg, var(--tertiary-orange) 0%, var(--tertiary-orange-dark) 100%) !important;
  color: white !important;
  border: none !important;
  font-weight: 600;
  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.3);
  animation: pulse-delayed 2s infinite;
  box-shadow: 0 0 10px rgba(249, 115, 22, 0.3);
}

@keyframes pulse-countdown {
  0%, 100% { 
    transform: scale(1);
  }
  50% { 
    transform: scale(1.05);
  }
}

@keyframes pulse-glow {
  0%, 100% { 
    box-shadow: 0 0 10px rgba(239, 68, 68, 0.3);
    transform: scale(1);
  }
  50% { 
    box-shadow: 0 0 20px rgba(239, 68, 68, 0.5);
    transform: scale(1.02);
  }
}

@keyframes pulse-delayed {
  0%, 100% { 
    box-shadow: 0 0 10px rgba(249, 115, 22, 0.3);
    transform: scale(1);
  }
  50% { 
    box-shadow: 0 0 20px rgba(249, 115, 22, 0.5);
    transform: scale(1.02);
  }
}

/* Enhanced Live Dot Animation */
.live-dot {
  display: inline-block;
  width: 8px;
  height: 8px;
  background-color: white;
  border-radius: 50%;
  margin-right: 6px;
  animation: pulse-dot 1.5s infinite;
  box-shadow: 0 0 4px rgba(255, 255, 255, 0.5);
}

@keyframes pulse-dot {
  0%, 100% { 
    opacity: 1;
    transform: scale(1);
  }
  50% { 
    opacity: 0.3;
    transform: scale(0.8);
  }
}

/* Delayed Dot Animation */
.delayed-dot {
  display: inline-block;
  width: 8px;
  height: 8px;
  background-color: white;
  border-radius: 50%;
  margin-right: 6px;
  animation: pulse-delayed-dot 2s infinite;
  box-shadow: 0 0 4px rgba(255, 255, 255, 0.5);
}

@keyframes pulse-delayed-dot {
  0%, 100% { 
    opacity: 1;
    transform: scale(1);
  }
  50% { 
    opacity: 0.4;
    transform: scale(0.7);
  }
}

/* Traditional Bootstrap Badges - Smaller */
.game-badge {
  padding: 4px 8px;
  font-weight: 500;
  font-size: 0.75rem;
  transition: all 0.15s ease;
  cursor: pointer;
  text-decoration: none;
  margin: 2px;
  border-radius: 4px;
}

.game-badge:hover {
  opacity: 0.8;
  transform: none;
  box-shadow: none;
}

/* Traditional Bootstrap Colors */
.badge.bg-success {
  background-color: #DC2626 !important; /* Match DataTable live badge red */
  color: white !important;
  border: none !important;
}

.badge.bg-info {
  background-color: #0dcaf0 !important;
  color: #000 !important;
  border: none !important;
}

.badge.bg-light {
  background-color: #f8f9fa !important;
  color: #212529 !important;
  border: 1px solid #dee2e6 !important;
}

/* Live badge dot for navigation badges */
.badge.bg-success .live-dot-nav {
  display: inline-block;
  width: 6px;
  height: 6px;
  background-color: white;
  border-radius: 50%;
  margin-right: 4px;
  animation: pulse-dot 1.5s infinite;
  box-shadow: 0 0 3px rgba(255, 255, 255, 0.5);
}

/* Enhanced Team Logos */
.team-logo {
  width: 16px;
  height: 16px;
  margin-right: 6px;
  vertical-align: middle;
  transition: transform 0.15s ease;
}

.team-logo:hover {
  transform: scale(1.2);
}

/* Enhanced Flash Animation */
@keyframes flash {
  0% { 
    background-color: #EF4444;
    color: white;
    transform: scale(1.05);
  }
  100% { 
    background-color: inherit;
    color: inherit;
    transform: scale(1);
  }
}

/* Enhanced Last Updated Text */
.last-updated {
  font-size: 0.75rem;
  color: var(--gray-600);
  margin-top: 2px;
  font-style: italic;
  opacity: 0.8;
}

/* Game Section Headers */
.game-header {
  font-family: 'Inter', sans-serif;
  font-weight: 600;
  margin-bottom: 1rem;
  display: flex;
  align-items: center;
  padding: 10px 0;
  border-bottom: 2px solid #E5E7EB;
}

.game-header img {
  transition: transform 0.2s ease;
}

.game-header img:hover {
  transform: scale(1.1);
}

/* Table Group Spacing */
.table-group {
  margin-bottom: 1rem;
  margin-left: auto;
  margin-right: auto;
  padding: .5rem .25rem .5rem .25rem;
  background: white;
  border-radius: 6px; /* Reduced from 12px */
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
  /* Expand to fit the widest child (e.g. wide odds tables) so the game
     header above stays aligned with the table width — but never shrink
     below the parent width when content is sparse (no data / collapsed). */
  width: fit-content;
  min-width: 100%;
  /* No max-width: card can grow past .container so the per-book 75px floor
     is honored when there are many books. */
}

/* Game Header Container */
.game-header-container {
  font-family: 'Inter', sans-serif;
  font-weight: 600;
  font-size: 1.1rem;
  margin-bottom: 1rem;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 8px 0;
  border-bottom: 2px solid #E5E7EB;
  color: #374151;
}

.game-header-container img {
  transition: transform 0.2s ease;
}

.game-header-container img:hover {
  transform: scale(1.1);
}

/* Enhanced Navbar */
.navbar-dark {
  background: linear-gradient(135deg, #1F2937 0%, #111827 100%) !important;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  z-index: 1030;
}

.navbar-brand {
  font-weight: 700;
  font-size: 1.5rem;
  letter-spacing: -0.025em;
}

/* Container Improvements */
.container {
  /* Allow the games container to expand horizontally when many books push
     odds-table min-width past 1400px. Body will horizontally scroll on
     narrow viewports — the alternative is squeezing odds columns below
     readability. */
  max-width: none;
}

/* Responsive Improvements */
@media (max-width: 768px) {
  .odds-cell {
    font-size: 0.8rem;
    padding: 8px 4px;
  }
  
  .team-logo {
    width: 14px;
    height: 14px;
  }
  
  .table-container {
    font-size: 0.875rem;
  }
  
  .game-badge {
    padding: 6px 12px;
    font-size: 0.8rem;
  }
  
  .navbar-brand {
    font-size: 1.25rem;
  }

  /* Mobile body padding */
  .container {
    padding-left: 8px;
    padding-right: 8px;
  }

  /* Mobile table width constraints */
  .table-group {
    max-width: 100vw;
    overflow-x: hidden;
  }

  .table-container table {
    table-layout: fixed;
    width: 100%;
  }

  /* Mobile player name column - increased from 25% to 35% */
  .player-name-cell,
  .player-name-cell-no-logo {
    max-width: 140px;
    min-width: 140px;
    width: 140px;
    font-size: 0.8rem;
  }

  /* Mobile odds columns - reduced width to accommodate larger name column */
  .odds-cell {
    width: 15%;
    min-width: 42px;
    padding: 6px 1px;
    font-size: 0.75rem;
  }
}

/* Smooth Scrolling */
html {
  scroll-behavior: smooth;
}

/* Focus States for Accessibility */
.game-badge:focus,
.odds-cell:focus {
  outline: 2px solid #3B82F6;
  outline-offset: 2px;
}

/* Footer Styling */
.app-footer {
  margin-top: 3rem;
  padding: 2rem 0;
  border-top: 1px solid #E5E7EB;
  text-align: center;
}

.footer-content {
  font-size: 0.875rem;
  color: var(--gray-600);
  opacity: 0.8;
  line-height: 1.5;
}

/* Final Game Message */
.final-game-message {
  text-align: center;
  padding: 3rem 2rem;
  color: var(--gray-600);
}

.final-game-message h4 {
  margin-bottom: 0.5rem;
  color: var(--gray-900);
  font-weight: 600;
}

.final-game-message p {
  margin: 0;
  font-size: 0.95rem;
  opacity: 0.8;
}

/* Skeleton Loading Animations */
.skeleton-text {
  height: 16px;
  background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);
  background-size: 200% 100%;
  animation: skeleton-loading 1.5s infinite;
  border-radius: 4px;
  width: 80%;
}

.skeleton-odds {
  height: 14px;
  background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);
  background-size: 200% 100%;
  animation: skeleton-loading 1.5s infinite;
  border-radius: 4px;
  width: 60%;
  margin: 0 auto;
}

@keyframes skeleton-loading {
  0% { background-position: 200% 0; }
  100% { background-position: -200% 0; }
}

/* Player Modal Styles */
/* Ensure player modals render above mobile trends overlay (z-index: 1100) */
.player-modal-backdrop {
  z-index: 1199 !important;
}
.player-modal,
.nba-player-modal,
.nfl-player-modal,
.nhl-player-modal,
.soccer-player-modal {
  z-index: 1200 !important;
}

.player-modal .modal-dialog {
  max-width: 900px !important;
  width: 900px !important;
  margin: 1rem auto;
}

/* NFL Player Modal Styles */
.nfl-player-modal .modal-dialog {
  max-width: 900px !important;
  width: 900px !important;
  margin: 1rem auto;
}

.player-modal .modal-content {
  border: none;
  border-radius: 12px;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3);
  backdrop-filter: blur(10px);
}

.player-modal .modal-header {
  border-bottom: 2px solid rgba(255, 255, 255, 0.1);
  padding: 1.5rem 2rem;
}

/* .player-modal close-button styling now lives in the unified rule below
   with the other player modals — see .*-player-modal .btn-close. */

.player-modal .modal-body {
  padding: 2rem;
  background: #f8f9fa;
}

.player-modal .modal-footer {
  border-top: 1px solid #e9ecef;
  padding: 1rem 2rem;
}

/* Chart container styling */
.player-modal canvas {
  border-radius: 8px;
  background: white;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

/* Summary cards styling */
.player-modal .card {
  border: none;
  border-radius: 8px;
  transition: transform 0.2s ease;
}

.player-modal .card:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}

/* Table styling within modal */
.player-modal .table-responsive {
  border-radius: 8px;
  border: 1px solid #e9ecef;
}

.player-modal .table {
  margin-bottom: 0;
}

.player-modal .table-dark {
  background-color: #495057;
}

/* Consistent bookmaker column widths */
.player-modal .table th:not(:first-child),
.player-modal .table td:not(:first-child),
.nfl-player-modal .table th:not(:first-child),
.nfl-player-modal .table td:not(:first-child) {
  min-width: 70px;
}

/* Mobile responsiveness for modal */
@media (max-width: 768px) {
  .player-modal .modal-dialog,
  .nhl-player-modal .modal-dialog,
  .nfl-player-modal .modal-dialog {
    max-width: 100vw !important;
    width: 100vw !important;
    margin: 0;
    height: 100vh;
  }
  
  .player-modal .modal-content,
  .nhl-player-modal .modal-content,
  .nfl-player-modal .modal-content {
    height: 100vh;
    border-radius: 0;
    /* Explicit flex column + hidden overflow makes the child modal-body the
       only scroll container; without this the whole modal scrolls as one
       and the header rides the body up. Bootstrap sets flex on .modal-content
       by default but iOS Safari plus fullscreen sometimes drops it. */
    display: flex;
    flex-direction: column;
    overflow: hidden;
  }

  .player-modal .modal-header,
  .nhl-player-modal .modal-header,
  .nfl-player-modal .modal-header {
    padding: 1rem;
    /* Pin the header — never shrink and never scroll off. */
    flex: 0 0 auto;
  }

  .player-modal .modal-body,
  .nhl-player-modal .modal-body,
  .nfl-player-modal .modal-body {
    padding: 1rem;
    flex: 1 1 auto;
    /* \`min-height: 0\` is the classic flexbox trick that lets a flex child
       shrink below its content size so overflow scrolls inside it instead
       of pushing the parent (and header) upward. */
    min-height: 0;
    overflow-y: auto;
    -webkit-overflow-scrolling: touch;
  }

  .player-modal .modal-footer,
  .nhl-player-modal .modal-footer,
  .nfl-player-modal .modal-footer {
    padding: 1rem;
  }
}

/* Dark mode team logo adjustments */
.dark-mode .team-logo {
  /* No filter needed - using proper white logos */
}

.dark-mode .best-bets-team-logo,
.dark-mode .best-bets-team-logo-small {
  /* No filter needed - using proper white logos */
}

/* Player Modal Takeover Styles */
.player-modal-takeover {
  position: fixed;
  top: 56px;
  left: 0;
  right: 0;
  bottom: 0;
  width: 100vw;
  height: calc(100vh - 56px);
  background: white;
  z-index: 1040;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  transform: translateY(100%);
  transition: transform 0.3s ease;
}

.player-modal-takeover.show {
  transform: translateY(0);
}

.player-modal-takeover-header {
  background: linear-gradient(135deg, #0d6efd 0%, #0a58ca 100%);
  color: white;
  padding: 1rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
}

.player-modal-takeover-body {
  flex: 1 1;
  overflow-y: auto;
  background: #f8f9fa;
  padding: 1rem;
}

/* Dark mode player modal takeover */
.dark-mode .player-modal-takeover {
  background: #1f2937;
}

.dark-mode .player-modal-takeover-header {
  background: linear-gradient(135deg, #1e40af 0%, #1e3a8a 100%);
  border-bottom: 1px solid #374151;
}

.dark-mode .player-modal-takeover-body {
  background: #111827;
  color: #e5e7eb;
}

/* Settings Takeover Styles */
.settings-takeover {
  position: fixed;
  top: 56px;
  left: 0;
  right: 0;
  bottom: 0;
  width: 100vw;
  height: calc(100vh - 56px);
  background: white;
  z-index: 2000;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

/* Desktop: max 50% width, centered */
@media (min-width: 769px) {
  .settings-takeover {
    left: 50%;
    transform: translateX(-50%);
    max-width: 50vw;
    width: 50vw;
    border-left: 1px solid #e5e7eb;
    border-right: 1px solid #e5e7eb;
  }

  .dark-mode .settings-takeover {
    border-left-color: #374151;
    border-right-color: #374151;
  }
}

.settings-takeover-header {
  background: linear-gradient(135deg, #374151 0%, #1f2937 100%);
  color: white;
  padding: 1rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
}

.settings-takeover-body {
  flex: 1 1;
  overflow-y: auto;
  background: #f3f4f6;
  padding: 1.5rem 0;
}

.settings-section {
  margin-bottom: 2rem;
  padding: 0 3px;
}

.settings-section-title {
  font-size: 0.875rem;
  font-weight: 600;
  color: #6b7280;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  margin-bottom: 1rem;
  border-bottom: 1px solid #e5e7eb;
  padding-bottom: 0.5rem;
}

.setting-item {
  background: white;
  border-radius: 8px;
  padding: 1rem;
  margin-bottom: 0.75rem;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
}

.setting-label {
  font-weight: 500;
  color: #1f2937;
  margin-bottom: 0.25rem;
}

.setting-description {
  font-size: 0.875rem;
  line-height: 1.4;
}

.setting-value {
  font-size: 0.875rem;
}

.setting-switch {
  transform: scale(1.2);
}

/* Dark mode settings takeover */
.dark-mode .settings-takeover {
  background: #1f2937;
}

.dark-mode .settings-takeover-header {
  background: linear-gradient(135deg, #111827 0%, #000000 100%);
  border-bottom: 1px solid #374151;
}

.dark-mode .settings-takeover-body {
  background: #111827;
  color: #e5e7eb;
}

.dark-mode .settings-section-title {
  color: #9ca3af;
  border-bottom-color: #374151;
}

/* Desktop: Settings as a panel like Best Bets (overrides default takeover) */
@media (min-width: 769px) {
  .settings-takeover.desktop-panel {
    top: 130px;
    left: 5px;
    right: 5px;
    bottom: 5px;
    transform: none;
    width: auto;
    max-width: none;
    height: auto;
    background: #212529;
    border: none;
    border-radius: 12px;
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.4);
    overflow: hidden;
    z-index: 2000;
  }

  .settings-takeover.desktop-panel .settings-takeover-header {
    background: #212529;
    border-bottom: 1px solid #333;
    padding: 8px 12px;
    box-shadow: none;
  }

  .settings-takeover.desktop-panel .settings-takeover-header h5 {
    font-family: 'Oswald', sans-serif;
    font-size: 1rem;
    font-weight: 600;
    letter-spacing: 0.04em;
    text-transform: uppercase;
  }

  .settings-takeover.desktop-panel .settings-takeover-body {
    background: #1a1d21;
    padding: 16px 20px;
    color: #e5e7eb;
  }

  .settings-takeover.desktop-panel .settings-takeover-body-grid {
    display: grid;
    grid-template-columns: 1fr 1fr 1fr;
    column-gap: 24px;
    row-gap: 4px;
    align-items: start;
  }

  .settings-takeover.desktop-panel .settings-takeover-body-grid > [data-col="1"] {
    grid-column: 1;
  }
  .settings-takeover.desktop-panel .settings-takeover-body-grid > [data-col="2"] {
    grid-column: 2;
  }
  .settings-takeover.desktop-panel .settings-takeover-body-grid > [data-col="3"] {
    grid-column: 3;
  }

  .settings-takeover.desktop-panel .settings-section {
    margin-bottom: 16px;
    padding: 0;
  }

  .settings-takeover.desktop-panel .settings-section-title {
    color: #e5e7eb;
    border-bottom-color: #333;
    margin-bottom: 12px;
  }

  .settings-takeover.desktop-panel .setting-item {
    background: #2a2d31;
    color: #e5e7eb;
    box-shadow: none;
    border: 1px solid #333;
  }

  .settings-takeover.desktop-panel .setting-label {
    color: #e5e7eb;
  }
}

.dark-mode .setting-item {
  background: #1f2937;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.3);
}

.dark-mode .setting-label {
  color: #e5e7eb;
}

.dark-mode .setting-description {
  color: #9ca3af;
}

.dark-mode .setting-value {
  color: #9ca3af;
}

/* Books grid in settings */
.books-grid {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  max-width: 400px;
}

@media (max-width: 768px) {
  .books-grid {
    max-width: 100%;
  }
}

.books-secondary-divider {
  margin: 0.75rem 0 0.5rem;
  padding: 0.5rem 0.75rem;
  border-top: 1px solid #cbd5e1;
  background: transparent;
}

.books-secondary-divider-label {
  font-size: 0.7rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.06em;
  color: #475569;
  margin-bottom: 0.25rem;
}

.books-secondary-divider-blurb {
  display: block;
  font-size: 0.72rem;
  line-height: 1.35;
  color: #64748b;
}

.dark-mode .books-secondary-divider,
.settings-takeover.desktop-panel .books-secondary-divider {
  border-top-color: #3f4651;
}

.dark-mode .books-secondary-divider-label,
.settings-takeover.desktop-panel .books-secondary-divider-label {
  color: #cbd5e1;
}

.dark-mode .books-secondary-divider-blurb,
.settings-takeover.desktop-panel .books-secondary-divider-blurb {
  color: #94a3b8;
}

.book-toggle-item {
  background: #f8f9fa;
  border-radius: 6px;
  padding: 0.75rem;
  border: 1px solid #e9ecef;
  cursor: grab;
  -webkit-user-select: none;
          user-select: none;
  transition: all 0.2s ease;
  position: relative;
}

.book-toggle-item:hover {
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  transform: translateY(-1px);
}

.book-toggle-item.dragging {
  opacity: 0.5;
  transform: rotate(5deg);
  cursor: grabbing;
}

.book-toggle-item.drag-over {
  border-color: #007bff;
  background-color: rgba(0, 123, 255, 0.1);
}

.drag-handle {
  color: #6c757d;
  margin-right: 8px;
  font-size: 14px;
  cursor: grab;
  padding: 2px;
}

.drag-handle:hover {
  color: #495057;
}

.book-name {
  font-size: 0.875rem;
  font-weight: 500;
}

.book-switch {
  transform: scale(0.9);
  pointer-events: auto;
}

/* Dark mode books grid */
.dark-mode .book-toggle-item {
  background: #374151;
  border-color: #4b5563;
}

.dark-mode .book-toggle-item:hover {
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.3);
}

.dark-mode .book-toggle-item.drag-over {
  border-color: #3b82f6;
  background-color: rgba(59, 130, 246, 0.1);
}

.dark-mode .book-name {
  color: #e5e7eb;
}

.dark-mode .drag-handle {
  color: #9ca3af;
}

.dark-mode .drag-handle:hover {
  color: #d1d5db;
}

/* Custom legend layout for mobile chart */
@media (max-width: 768px) {
  .player-modal-takeover .chartjs-legend {
    display: flex !important;
    flex-wrap: wrap !important;
    justify-content: center !important;
    gap: 8px !important;
  }
  
  .player-modal-takeover .chartjs-legend ul {
    display: flex !important;
    flex-wrap: wrap !important;
    justify-content: center !important;
    gap: 8px !important;
    width: 100% !important;
    padding: 0 !important;
    margin: 0 !important;
  }
  
  .player-modal-takeover .chartjs-legend li {
    flex-grow: 0;
    flex-shrink: 0;
    flex-basis: calc(33.33% - 8px);
    text-align: center !important;
    margin: 0 !important;
    padding: 4px !important;
    display: flex !important;
    align-items: center !important;
    justify-content: center !important;
    font-size: 10px !important;
  }
}

/* Mobile touch drag styling */
@media (max-width: 768px) {
  .book-toggle-item {
    touch-action: manipulation;
  }

  .book-toggle-item:active {
    transform: scale(0.98);
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  }
}

/* Authentication blur effect for odds */
.odds-blur {
  filter: blur(5px);
  -webkit-user-select: none;
          user-select: none;
  pointer-events: none;
  transition: filter 0.3s ease;
}

.odds-blur:hover {
  filter: blur(5px);
}

/* Mobile checkout modal - remove all margins */
@media (max-width: 768px) {
  .checkout-modal-mobile {
    margin: 0 !important;
  }

  .checkout-modal-mobile .modal-content {
    margin: 0 !important;
    padding: 0 !important;
    border-radius: 0 !important;
  }

  .checkout-modal-mobile .modal-body {
    padding: 0 !important;
  }
}

/* Spinner animation for checkout status */
@keyframes spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}

/* Betslip add animation */
@keyframes betAddPulse {
  0% {
    background-color: rgba(255, 193, 7, 0.3);
    transform: scale(1);
  }
  50% {
    background-color: rgba(255, 193, 7, 0.6);
    transform: scale(1.05);
  }
  100% {
    background-color: transparent;
    transform: scale(1);
  }
}

.bet-add-animation {
  animation: betAddPulse 0.5s ease-out;
}

/* Betslip button bounce */
@keyframes buttonBounce {
  0%, 100% {
    transform: scale(1);
  }
  25% {
    transform: scale(1.15);
  }
  50% {
    transform: scale(1.05);
  }
  75% {
    transform: scale(1.1);
  }
}

.betslip-button-bounce {
  animation: buttonBounce 0.5s ease-out;
}

/* Toast slide in animation */
@keyframes slideInRight {
  from {
    transform: translateX(400px);
    opacity: 0;
  }
  to {
    transform: translateX(0);
    opacity: 1;
  }
}

/* Bottom-center toast: fade + slight rise. Purely opacity/translateY so it
   composes with a fixed translateX(-50%) horizontal centering. */
@keyframes toastFadeUp {
  from {
    opacity: 0;
    transform: translateX(-50%) translateY(8px);
  }
  to {
    opacity: 1;
    transform: translateX(-50%) translateY(0);
  }
}

/* All mobile player modals — enlarge the top-right close X so it's an easy
   tap target on mobile, and shift the default black glyph to a medium grey
   so it reads as a control without punching a hard black hole against the
   near-white header. Hover deepens the grey and adds a subtle circular wash.
   Consistent across NFL, NHL, NBA/WNBA, MLB/NCAAB, and Soccer modals. */
.nfl-player-modal .modal-header .btn-close,
.nhl-player-modal .modal-header .btn-close,
.nba-player-modal .modal-header .btn-close,
.player-modal .modal-header .btn-close,
.soccer-player-modal .modal-header .btn-close {
  width: 1.75rem;
  height: 1.75rem;
  padding: 0.75rem;
  background-size: 1.25rem;
  opacity: 1;
  border-radius: 50%;
  filter: invert(45%) sepia(6%) saturate(0%) brightness(95%);
  transition: filter 0.15s ease, background-color 0.15s ease;
}
.nfl-player-modal .modal-header .btn-close:hover,
.nfl-player-modal .modal-header .btn-close:focus,
.nhl-player-modal .modal-header .btn-close:hover,
.nhl-player-modal .modal-header .btn-close:focus,
.nba-player-modal .modal-header .btn-close:hover,
.nba-player-modal .modal-header .btn-close:focus,
.player-modal .modal-header .btn-close:hover,
.player-modal .modal-header .btn-close:focus,
.soccer-player-modal .modal-header .btn-close:hover,
.soccer-player-modal .modal-header .btn-close:focus {
  filter: invert(25%) sepia(6%) saturate(0%) brightness(95%);
  background-color: rgba(0, 0, 0, 0.06);
  box-shadow: none;
}

/* Announcements button pulse animation */
@keyframes pulse-announcement {
  0%, 100% {
    box-shadow: 0 0 12px rgba(251, 191, 36, 0.5), 0 2px 8px rgba(0, 0, 0, 0.3);
  }
  50% {
    box-shadow: 0 0 20px rgba(251, 191, 36, 0.8), 0 2px 8px rgba(0, 0, 0, 0.3);
  }
}

/* Announcements dot pulse animation */
@keyframes pulse-dot {
  0%, 100% {
    transform: scale(1);
    opacity: 1;
  }
  50% {
    transform: scale(1.3);
    opacity: 0.7;
  }
}
/* Dark scrollbar styling for panels and modals */
.dark-scrollbar::-webkit-scrollbar,
.dark-panel ::-webkit-scrollbar,
.dark-panel::-webkit-scrollbar {
  height: 6px;
  width: 6px;
}

.dark-scrollbar::-webkit-scrollbar-track,
.dark-panel ::-webkit-scrollbar-track,
.dark-panel::-webkit-scrollbar-track {
  background: #111;
  border-radius: 3px;
}

.dark-scrollbar::-webkit-scrollbar-thumb,
.dark-panel ::-webkit-scrollbar-thumb,
.dark-panel::-webkit-scrollbar-thumb {
  background: #333;
  border-radius: 3px;
}

.dark-scrollbar::-webkit-scrollbar-thumb:hover,
.dark-panel ::-webkit-scrollbar-thumb:hover,
.dark-panel::-webkit-scrollbar-thumb:hover {
  background: #444;
}

/* Circled-icon buttons (Leaders, Neg Corr).
   Desktop variant: the chip ships with a solid warning-yellow background
   and \`color:#000\` inline, so the pill is always visible on the dark page.
   On hover Bootstrap fills the whole button yellow, so we flip the chip's
   border to black to keep the pill shape visible against the matching
   yellow surface.
   Mobile variant: the chip ships with no inline background and no color
   override, so the pill reads as just a yellow outline with a yellow icon
   (inherited \`currentColor\`). On tap (\`:active\`) the chip fills warning
   yellow and the icon switches to black, giving a clear press response.
   The same rule covers desktop \`:active\` without changing the already-
   yellow pill. */
.circled-icon-btn:hover .circled-icon-chip {
  border-color: #000 !important;
}
.circled-icon-btn:active .circled-icon-chip,
.circled-icon-btn.active .circled-icon-chip {
  background-color: #ffc107 !important;
  color: #000 !important;
}
`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA,wBAAwB;;AAGxB;EACE,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE;IACE,4CAA4C;EAC9C;AACF;;AAEA;EACE,yBAAyB;EACzB,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,6BAA6B;EAC7B,YAAY;AACd;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE;IACE,uBAAuB;EACzB;EACA;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE,mEAAmE;EACnE,6BAA6B,EAAE,6BAA6B;AAC9D;;AAEA,6BAA6B;AAC7B;EACE,wBAAwB;EACxB,6BAA6B;EAC7B,2BAA2B;EAC3B,gCAAgC;EAChC,0BAA0B;EAC1B,+BAA+B;EAC/B,qBAAqB;EACrB,0BAA0B;EAC1B,kBAAkB;EAClB,mBAAmB;EACnB,mBAAmB;EACnB,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA,2BAA2B;AAC3B;EACE,kBAAkB;EAClB,gBAAgB;EAChB,wCAAwC;EACxC,kBAAkB;EAClB,aAAa;EACb,sBAAsB;AACxB;;AAEA,wCAAwC;AACxC;EACE,2BAA2B;AAC7B;;AAEA,2BAA2B;AAC3B;EACE,4BAA4B;EAC5B,uBAAuB;AACzB;;AAEA;EACE,4BAA4B;EAC5B,uBAAuB;AACzB;;AAEA;EACE,uBAAuB;AACzB;;AAEA,iDAAiD;AACjD;;EAEE,0CAA0C;AAC5C;;AAEA;;EAEE,+BAA+B;EAC/B,2BAA2B;AAC7B;AACA;EACE,wBAAwB;AAC1B;;AAEA;EACE,gBAAgB;EAChB,SAAO;EACP,cAAc;EACd,WAAW;AACb;;AAEA;EACE,uCAAuC;EACvC,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,4EAA4E;EAC5E,gBAAgB;EAChB,mBAAmB;EACnB,uBAAuB;EACvB,yBAAyB;EACzB,cAAc;EACd,gCAAgC;EAChC,sBAAsB;EACtB,YAAY;EACZ,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,sBAAsB;EACtB,YAAY;EACZ,gBAAgB;EAChB,cAAc;AAChB;;AAEA,oCAAoC;AACpC;EACE,qCAAqC;EACrC,uCAAuC;EACvC,0CAA0C;EAC1C,6BAA6B;EAC7B,6BAA6B;EAC7B,2BAA2B;EAC3B,iCAAiC;EACjC,uBAAuB;EACvB,yBAAyB;EACzB,8BAA8B;EAC9B,2BAA2B;EAC3B,kCAAkC;AACpC;;AAEA;EACE,4BAA4B;EAC5B,6BAA6B;EAC7B,2BAA2B;EAC3B,iCAAiC;EACjC,uBAAuB;EACvB,yBAAyB;EACzB,8BAA8B;EAC9B,2BAA2B;EAC3B,kCAAkC;AACpC;;AAEA,+BAA+B;AAC/B;EACE,iDAAiD;AACnD;;AAEA,gCAAgC;AAChC;EACE,qBAAqB;EACrB,yBAAyB;EACzB,oEAA+K;EAC/K,2CAA2C;EAC3C,mCAAmC;EACnC,uCAAuC;EACvC,oCAAoC;EACpC,gDAAgD;EAChD,6BAA6B;EAC7B,4DAA4D;AAC9D;;AAEA;EACE,4CAA4C;EAC5C,oEAAqL;EACrL,oCAAoC;EACpC,gCAAgC;AAClC;;AAEA;EACE,oEAA+K;EAC/K,oCAAoC;EACpC,4CAA4C;EAC5C,6DAA6D;AAC/D;;AAEA;EACE,oEAAqL;EACrL,oCAAoC;EACpC,gCAAgC;AAClC;;AAEA;EACE,sBAAsB;EACtB,WAAW;EACX,kBAAkB;EAClB,0CAA0C;AAC5C;;AAEA,kCAAkC;AAClC;EACE,iGAAiG;EACjG,2CAA2C;EAC3C,iCAAiC;EACjC,uBAAuB;EACvB,gBAAgB;EAChB,yCAAyC;AAC3C;;AAEA,oBAAoB;AACpB;EACE,6GAA6G;EAC7G,uBAAuB;EACvB,uBAAuB;EACvB,gBAAgB;EAChB,yCAAyC;EACzC,sCAAsC;AACxC;;AAEA,kBAAkB;AAClB;EACE,2GAA2G;EAC3G,uBAAuB;EACvB,uBAAuB;EACvB,gBAAgB;EAChB,yCAAyC;EACzC,oCAAoC;EACpC,4CAA4C;AAC9C;;AAEA;EACE;IACE,mBAAmB;EACrB;EACA;IACE,sBAAsB;EACxB;AACF;;AAEA;EACE;IACE,2CAA2C;IAC3C,mBAAmB;EACrB;EACA;IACE,2CAA2C;IAC3C,sBAAsB;EACxB;AACF;;AAEA;EACE;IACE,4CAA4C;IAC5C,mBAAmB;EACrB;EACA;IACE,4CAA4C;IAC5C,sBAAsB;EACxB;AACF;;AAEA,gCAAgC;AAChC;EACE,qBAAqB;EACrB,UAAU;EACV,WAAW;EACX,uBAAuB;EACvB,kBAAkB;EAClB,iBAAiB;EACjB,kCAAkC;EAClC,4CAA4C;AAC9C;;AAEA;EACE;IACE,UAAU;IACV,mBAAmB;EACrB;EACA;IACE,YAAY;IACZ,qBAAqB;EACvB;AACF;;AAEA,0BAA0B;AAC1B;EACE,qBAAqB;EACrB,UAAU;EACV,WAAW;EACX,uBAAuB;EACvB,kBAAkB;EAClB,iBAAiB;EACjB,wCAAwC;EACxC,4CAA4C;AAC9C;;AAEA;EACE;IACE,UAAU;IACV,mBAAmB;EACrB;EACA;IACE,YAAY;IACZ,qBAAqB;EACvB;AACF;;AAEA,2CAA2C;AAC3C;EACE,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,0BAA0B;EAC1B,eAAe;EACf,qBAAqB;EACrB,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,gBAAgB;AAClB;;AAEA,iCAAiC;AACjC;EACE,oCAAoC,EAAE,mCAAmC;EACzE,uBAAuB;EACvB,uBAAuB;AACzB;;AAEA;EACE,oCAAoC;EACpC,sBAAsB;EACtB,uBAAuB;AACzB;;AAEA;EACE,oCAAoC;EACpC,yBAAyB;EACzB,oCAAoC;AACtC;;AAEA,yCAAyC;AACzC;EACE,qBAAqB;EACrB,UAAU;EACV,WAAW;EACX,uBAAuB;EACvB,kBAAkB;EAClB,iBAAiB;EACjB,kCAAkC;EAClC,4CAA4C;AAC9C;;AAEA,wBAAwB;AACxB;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,sBAAsB;EACtB,gCAAgC;AAClC;;AAEA;EACE,qBAAqB;AACvB;;AAEA,6BAA6B;AAC7B;EACE;IACE,yBAAyB;IACzB,YAAY;IACZ,sBAAsB;EACxB;EACA;IACE,yBAAyB;IACzB,cAAc;IACd,mBAAmB;EACrB;AACF;;AAEA,+BAA+B;AAC/B;EACE,kBAAkB;EAClB,sBAAsB;EACtB,eAAe;EACf,kBAAkB;EAClB,YAAY;AACd;;AAEA,yBAAyB;AACzB;EACE,gCAAgC;EAChC,gBAAgB;EAChB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,gCAAgC;AAClC;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,qBAAqB;AACvB;;AAEA,wBAAwB;AACxB;EACE,mBAAmB;EACnB,iBAAiB;EACjB,kBAAkB;EAClB,kCAAkC;EAClC,iBAAiB;EACjB,kBAAkB,EAAE,sBAAsB;EAC1C,yCAAyC;EACzC;;2EAEyE;EACzE,kBAAkB;EAClB,eAAe;EACf;4CAC0C;AAC5C;;AAEA,0BAA0B;AAC1B;EACE,gCAAgC;EAChC,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,gCAAgC;EAChC,cAAc;AAChB;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,qBAAqB;AACvB;;AAEA,oBAAoB;AACpB;EACE,wEAAwE;EACxE,yCAAyC;EACzC,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,wBAAwB;AAC1B;;AAEA,2BAA2B;AAC3B;EACE;;;mBAGiB;EACjB,eAAe;AACjB;;AAEA,4BAA4B;AAC5B;EACE;IACE,iBAAiB;IACjB,gBAAgB;EAClB;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,iBAAiB;IACjB,iBAAiB;EACnB;;EAEA;IACE,kBAAkB;EACpB;;EAEA,wBAAwB;EACxB;IACE,iBAAiB;IACjB,kBAAkB;EACpB;;EAEA,mCAAmC;EACnC;IACE,gBAAgB;IAChB,kBAAkB;EACpB;;EAEA;IACE,mBAAmB;IACnB,WAAW;EACb;;EAEA,0DAA0D;EAC1D;;IAEE,gBAAgB;IAChB,gBAAgB;IAChB,YAAY;IACZ,iBAAiB;EACnB;;EAEA,0EAA0E;EAC1E;IACE,UAAU;IACV,eAAe;IACf,gBAAgB;IAChB,kBAAkB;EACpB;AACF;;AAEA,qBAAqB;AACrB;EACE,uBAAuB;AACzB;;AAEA,mCAAmC;AACnC;;EAEE,0BAA0B;EAC1B,mBAAmB;AACrB;;AAEA,mBAAmB;AACnB;EACE,gBAAgB;EAChB,eAAe;EACf,6BAA6B;EAC7B,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,sBAAsB;EACtB,YAAY;EACZ,gBAAgB;AAClB;;AAEA,uBAAuB;AACvB;EACE,kBAAkB;EAClB,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,qBAAqB;EACrB,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,YAAY;AACd;;AAEA,gCAAgC;AAChC;EACE,YAAY;EACZ,yEAAyE;EACzE,0BAA0B;EAC1B,yCAAyC;EACzC,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,YAAY;EACZ,yEAAyE;EACzE,0BAA0B;EAC1B,yCAAyC;EACzC,kBAAkB;EAClB,UAAU;EACV,cAAc;AAChB;;AAEA;EACE,KAAK,2BAA2B,EAAE;EAClC,OAAO,4BAA4B,EAAE;AACvC;;AAEA,wBAAwB;AACxB,4EAA4E;AAC5E;EACE,wBAAwB;AAC1B;AACA;;;;;EAKE,wBAAwB;AAC1B;;AAEA;EACE,2BAA2B;EAC3B,uBAAuB;EACvB,iBAAiB;AACnB;;AAEA,4BAA4B;AAC5B;EACE,2BAA2B;EAC3B,uBAAuB;EACvB,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,0CAA0C;EAC1C,2BAA2B;AAC7B;;AAEA;EACE,iDAAiD;EACjD,oBAAoB;AACtB;;AAEA;mEACmE;;AAEnE;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,6BAA6B;EAC7B,kBAAkB;AACpB;;AAEA,4BAA4B;AAC5B;EACE,kBAAkB;EAClB,iBAAiB;EACjB,wCAAwC;AAC1C;;AAEA,0BAA0B;AAC1B;EACE,YAAY;EACZ,kBAAkB;EAClB,+BAA+B;AACjC;;AAEA;EACE,2BAA2B;EAC3B,yCAAyC;AAC3C;;AAEA,+BAA+B;AAC/B;EACE,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,uCAAuC;AACvC;;;;EAIE,eAAe;AACjB;;AAEA,oCAAoC;AACpC;EACE;;;IAGE,2BAA2B;IAC3B,uBAAuB;IACvB,SAAS;IACT,aAAa;EACf;;EAEA;;;IAGE,aAAa;IACb,gBAAgB;IAChB;;;sEAGkE;IAClE,aAAa;IACb,sBAAsB;IACtB,gBAAgB;EAClB;;EAEA;;;IAGE,aAAa;IACb,wDAAwD;IACxD,cAAc;EAChB;;EAEA;;;IAGE,aAAa;IACb,cAAc;IACd;;mDAE+C;IAC/C,aAAa;IACb,gBAAgB;IAChB,iCAAiC;EACnC;;EAEA;;;IAGE,aAAa;EACf;AACF;;AAEA,oCAAoC;AACpC;EACE,gDAAgD;AAClD;;AAEA;;EAEE,gDAAgD;AAClD;;AAEA,iCAAiC;AACjC;EACE,eAAe;EACf,SAAS;EACT,OAAO;EACP,QAAQ;EACR,SAAS;EACT,YAAY;EACZ,0BAA0B;EAC1B,iBAAiB;EACjB,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,2BAA2B;EAC3B,+BAA+B;AACjC;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,6DAA6D;EAC7D,YAAY;EACZ,aAAa;EACb,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,yCAAyC;AAC3C;;AAEA;EACE,SAAO;EACP,gBAAgB;EAChB,mBAAmB;EACnB,aAAa;AACf;;AAEA,oCAAoC;AACpC;EACE,mBAAmB;AACrB;;AAEA;EACE,6DAA6D;EAC7D,gCAAgC;AAClC;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA,6BAA6B;AAC7B;EACE,eAAe;EACf,SAAS;EACT,OAAO;EACP,QAAQ;EACR,SAAS;EACT,YAAY;EACZ,0BAA0B;EAC1B,iBAAiB;EACjB,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA,qCAAqC;AACrC;EACE;IACE,SAAS;IACT,2BAA2B;IAC3B,eAAe;IACf,WAAW;IACX,8BAA8B;IAC9B,+BAA+B;EACjC;;EAEA;IACE,0BAA0B;IAC1B,2BAA2B;EAC7B;AACF;;AAEA;EACE,6DAA6D;EAC7D,YAAY;EACZ,aAAa;EACb,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,yCAAyC;AAC3C;;AAEA;EACE,SAAO;EACP,gBAAgB;EAChB,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;EACd,yBAAyB;EACzB,sBAAsB;EACtB,mBAAmB;EACnB,gCAAgC;EAChC,sBAAsB;AACxB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,wCAAwC;AAC1C;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;AACvB;;AAEA,gCAAgC;AAChC;EACE,mBAAmB;AACrB;;AAEA;EACE,6DAA6D;EAC7D,gCAAgC;AAClC;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,4BAA4B;AAC9B;;AAEA,6EAA6E;AAC7E;EACE;IACE,UAAU;IACV,SAAS;IACT,UAAU;IACV,WAAW;IACX,eAAe;IACf,WAAW;IACX,eAAe;IACf,YAAY;IACZ,mBAAmB;IACnB,YAAY;IACZ,mBAAmB;IACnB,yCAAyC;IACzC,gBAAgB;IAChB,aAAa;EACf;;EAEA;IACE,mBAAmB;IACnB,6BAA6B;IAC7B,iBAAiB;IACjB,gBAAgB;EAClB;;EAEA;IACE,iCAAiC;IACjC,eAAe;IACf,gBAAgB;IAChB,sBAAsB;IACtB,yBAAyB;EAC3B;;EAEA;IACE,mBAAmB;IACnB,kBAAkB;IAClB,cAAc;EAChB;;EAEA;IACE,aAAa;IACb,kCAAkC;IAClC,gBAAgB;IAChB,YAAY;IACZ,kBAAkB;EACpB;;EAEA;IACE,cAAc;EAChB;EACA;IACE,cAAc;EAChB;EACA;IACE,cAAc;EAChB;;EAEA;IACE,mBAAmB;IACnB,UAAU;EACZ;;EAEA;IACE,cAAc;IACd,yBAAyB;IACzB,mBAAmB;EACrB;;EAEA;IACE,mBAAmB;IACnB,cAAc;IACd,gBAAgB;IAChB,sBAAsB;EACxB;;EAEA;IACE,cAAc;EAChB;AACF;;AAEA;EACE,mBAAmB;EACnB,wCAAwC;AAC1C;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA,2BAA2B;AAC3B;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE;IACE,eAAe;EACjB;AACF;;AAEA;EACE,wBAAwB;EACxB,uBAAuB;EACvB,6BAA6B;EAC7B,uBAAuB;AACzB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,iBAAiB;EACjB,cAAc;AAChB;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA;;EAEE,cAAc;AAChB;;AAEA;;EAEE,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,YAAY;EACZ,yBAAiB;UAAjB,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,wCAAwC;EACxC,2BAA2B;AAC7B;;AAEA;EACE,YAAY;EACZ,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,wCAAwC;AAC1C;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,eAAe;EACf,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,oBAAoB;AACtB;;AAEA,yBAAyB;AACzB;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,qBAAqB;EACrB,yCAAyC;AAC3C;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA,0CAA0C;AAC1C;EACE;IACE,wBAAwB;IACxB,0BAA0B;IAC1B,kCAAkC;IAClC,mBAAmB;EACrB;;EAEA;IACE,wBAAwB;IACxB,0BAA0B;IAC1B,kCAAkC;IAClC,mBAAmB;IACnB,sBAAsB;IACtB,qBAAqB;IACrB,oBAAoB;EACtB;;EAEA;IACE,YAAuC;IAAvC,cAAuC;IAAvC,8BAAuC;IACvC,6BAA6B;IAC7B,oBAAoB;IACpB,uBAAuB;IACvB,wBAAwB;IACxB,8BAA8B;IAC9B,kCAAkC;IAClC,0BAA0B;EAC5B;AACF;;AAEA,8BAA8B;AAC9B;EACE;IACE,0BAA0B;EAC5B;;EAEA;IACE,sBAAsB;IACtB,0CAA0C;EAC5C;AACF;;AAEA,wCAAwC;AACxC;EACE,iBAAiB;EACjB,yBAAiB;UAAjB,iBAAiB;EACjB,oBAAoB;EACpB,4BAA4B;AAC9B;;AAEA;EACE,iBAAiB;AACnB;;AAEA,+CAA+C;AAC/C;EACE;IACE,oBAAoB;EACtB;;EAEA;IACE,oBAAoB;IACpB,qBAAqB;IACrB,2BAA2B;EAC7B;;EAEA;IACE,qBAAqB;EACvB;AACF;;AAEA,0CAA0C;AAC1C;EACE;IACE,uBAAuB;EACzB;EACA;IACE,yBAAyB;EAC3B;AACF;;AAEA,0BAA0B;AAC1B;EACE;IACE,wCAAwC;IACxC,mBAAmB;EACrB;EACA;IACE,wCAAwC;IACxC,sBAAsB;EACxB;EACA;IACE,6BAA6B;IAC7B,mBAAmB;EACrB;AACF;;AAEA;EACE,oCAAoC;AACtC;;AAEA,0BAA0B;AAC1B;EACE;IACE,mBAAmB;EACrB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,qBAAqB;EACvB;AACF;;AAEA;EACE,qCAAqC;AACvC;;AAEA,6BAA6B;AAC7B;EACE;IACE,4BAA4B;IAC5B,UAAU;EACZ;EACA;IACE,wBAAwB;IACxB,UAAU;EACZ;AACF;;AAEA;iEACiE;AACjE;EACE;IACE,UAAU;IACV,2CAA2C;EAC7C;EACA;IACE,UAAU;IACV,yCAAyC;EAC3C;AACF;;AAEA;;;;wEAIwE;AACxE;;;;;EAKE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,wBAAwB;EACxB,UAAU;EACV,kBAAkB;EAClB,0DAA0D;EAC1D,0DAA0D;AAC5D;AACA;;;;;;;;;;EAUE,0DAA0D;EAC1D,qCAAqC;EACrC,gBAAgB;AAClB;;AAEA,yCAAyC;AACzC;EACE;IACE,0EAA0E;EAC5E;EACA;IACE,0EAA0E;EAC5E;AACF;;AAEA,sCAAsC;AACtC;EACE;IACE,mBAAmB;IACnB,UAAU;EACZ;EACA;IACE,qBAAqB;IACrB,YAAY;EACd;AACF;AACA,iDAAiD;AACjD;;;EAGE,WAAW;EACX,UAAU;AACZ;;AAEA;;;EAGE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;;;EAGE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;;;EAGE,gBAAgB;AAClB;;AAEA;;;;;;;;;;;iBAWiB;AACjB;EACE,6BAA6B;AAC/B;AACA;;EAEE,oCAAoC;EACpC,sBAAsB;AACxB","sourcesContent":["/* Enhanced Typography */\n@import url('https://fonts.googleapis.com/css2?family=Bebas+Neue&family=Inter:wght@400;500;600;700&family=Oswald:wght@400;500;600;700&display=swap');\n\n.App {\n  text-align: center;\n}\n\n.App-logo {\n  height: 40vmin;\n  pointer-events: none;\n}\n\n@media (prefers-reduced-motion: no-preference) {\n  .App-logo {\n    animation: App-logo-spin infinite 20s linear;\n  }\n}\n\n.App-header {\n  background-color: #282c34;\n  min-height: 100vh;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  font-size: calc(10px + 2vmin);\n  color: white;\n}\n\n.App-link {\n  color: #61dafb;\n}\n\n@keyframes App-logo-spin {\n  from {\n    transform: rotate(0deg);\n  }\n  to {\n    transform: rotate(360deg);\n  }\n}\n\nbody, .table, .text-start {\n  font-family: 'Inter', -apple-system, BlinkMacSystemFont, sans-serif;\n  font-feature-settings: 'tnum'; /* Tabular numbers for odds */\n}\n\n/* Enhanced Color Variables */\n:root {\n  --primary-green: #059669;\n  --primary-green-dark: #047857;\n  --secondary-yellow: #F59E0B;\n  --secondary-yellow-dark: #D97706;\n  --tertiary-orange: #F97316;\n  --tertiary-orange-dark: #EA580C;\n  --danger-red: #EF4444;\n  --danger-red-dark: #DC2626;\n  --gray-50: #F9FAFB;\n  --gray-100: #F3F4F6;\n  --gray-600: #4B5563;\n  --gray-900: #111827;\n  --text-gold: #FBBF24;\n}\n\n/* Enhanced Table Styling */\n.table-container {\n  border-radius: 4px;\n  overflow: hidden;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);\n  margin-bottom: 8px;\n  display: flex;\n  flex-direction: column;\n}\n\n/* Mobile matchups spacing adjustments */\n.mobile-matchups-table {\n  margin-bottom: 0 !important;\n}\n\n/* Fix empty table height */\n.mobile-matchups-table table {\n  min-height: unset !important;\n  height: auto !important;\n}\n\n.mobile-matchups-table tbody {\n  min-height: unset !important;\n  height: auto !important;\n}\n\n.mobile-matchups-table tbody tr:only-child td {\n  padding: 8px !important;\n}\n\n/* Pitcher row styling - force background color */\n.pitcher-row,\n.pitcher-row:hover {\n  background-color: rgb(26,26,26) !important;\n}\n\n.pitcher-row td,\n.pitcher-row:hover td {\n  background-color: rgb(26,26,26);\n  /*color: white !important;*/\n}\n.pitcher-row td:first-child, .pitcher-row th:first-child {\n  color: yellow !important;\n}\n\n.table {\n  margin-bottom: 0;\n  flex: 1;\n  display: table;\n  width: 100%;\n}\n\n.table tbody tr {\n  transition: background-color 0.15s ease;\n  height: 32px;\n  line-height: 1;\n}\n\n.table thead tr {\n  height: 30px;\n  line-height: 1;\n}\n\n.table tbody tr:hover {\n  background-color: rgba(59, 130, 246, 0.05);\n}\n\n.table th {\n  background: linear-gradient(135deg, var(--gray-50) 0%, var(--gray-100) 100%);\n  font-weight: 600;\n  font-size: 0.875rem;\n  letter-spacing: 0.025em;\n  text-transform: uppercase;\n  color: #374151;\n  border-bottom: 2px solid #E5E7EB;\n  vertical-align: middle;\n  height: 30px;\n  padding: 4px 8px;\n  line-height: 1;\n}\n\n.table td {\n  vertical-align: middle;\n  height: 32px;\n  padding: 4px 8px;\n  line-height: 1;\n}\n\n/* Player name cell with team logo */\n.player-name-cell {\n  background-size: 16px 16px !important;\n  background-repeat: no-repeat !important;\n  background-position: 6px center !important;\n  padding-left: 28px !important;\n  padding-right: 8px !important;\n  text-align: left !important;\n  vertical-align: middle !important;\n  height: 32px !important;\n  line-height: 1 !important;\n  white-space: nowrap !important;\n  overflow: hidden !important;\n  text-overflow: ellipsis !important;\n}\n\n.player-name-cell-no-logo {\n  padding-left: 8px !important;\n  padding-right: 8px !important;\n  text-align: left !important;\n  vertical-align: middle !important;\n  height: 32px !important;\n  line-height: 1 !important;\n  white-space: nowrap !important;\n  overflow: hidden !important;\n  text-overflow: ellipsis !important;\n}\n\n/* Enhanced Odds Cell Styling */\n.odds-cell {\n  transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);\n}\n\n/* Force toggle switch styling */\n.form-check-input[type=\"checkbox\"][role=\"switch\"] {\n  width: 2em !important;\n  margin-left: 0 !important;\n  background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'%3e%3ccircle r='3' fill='rgba%280,0,0,.25%29'/%3e%3c/svg%3e\") !important;\n  background-position: left center !important;\n  background-size: contain !important;\n  background-repeat: no-repeat !important;\n  background-color: #6c757d !important;\n  border: 1px solid rgba(0, 0, 0, 0.25) !important;\n  border-radius: 2em !important;\n  transition: background-position 0.15s ease-in-out !important;\n}\n\n.form-check-input[type=\"checkbox\"][role=\"switch\"]:checked {\n  background-position: right center !important;\n  background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'%3e%3ccircle r='3' fill='rgba%28255,255,255,1.0%29'/%3e%3c/svg%3e\") !important;\n  background-color: #0d6efd !important;\n  border-color: #0d6efd !important;\n}\n\n.form-check-input[type=\"checkbox\"][role=\"switch\"]:focus {\n  background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'%3e%3ccircle r='3' fill='rgba%280,0,0,.25%29'/%3e%3c/svg%3e\") !important;\n  background-color: #6c757d !important;\n  border-color: rgba(0, 0, 0, 0.25) !important;\n  box-shadow: 0 0 0 0.25rem rgba(13, 110, 253, 0.25) !important;\n}\n\n.form-check-input[type=\"checkbox\"][role=\"switch\"]:checked:focus {\n  background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'%3e%3ccircle r='3' fill='rgba%28255,255,255,1.0%29'/%3e%3c/svg%3e\") !important;\n  background-color: #0d6efd !important;\n  border-color: #0d6efd !important;\n}\n\n.odds-cell:hover {\n  transform: scale(1.05);\n  z-index: 10;\n  position: relative;\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);\n}\n\n/* Enhanced Live Badge with Glow */\n.live-badge {\n  background: linear-gradient(135deg, var(--danger-red) 0%, var(--danger-red-dark) 100%) !important;\n  box-shadow: 0 0 10px rgba(239, 68, 68, 0.3);\n  animation: pulse-glow 2s infinite;\n  border: none !important;\n  font-weight: 600;\n  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.3);\n}\n\n/* Countdown Badge */\n.countdown-badge {\n  background: linear-gradient(135deg, var(--secondary-yellow) 0%, var(--secondary-yellow-dark) 100%) !important;\n  color: white !important;\n  border: none !important;\n  font-weight: 600;\n  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.3);\n  animation: pulse-countdown 1s infinite;\n}\n\n/* Delayed Badge */\n.delayed-badge {\n  background: linear-gradient(135deg, var(--tertiary-orange) 0%, var(--tertiary-orange-dark) 100%) !important;\n  color: white !important;\n  border: none !important;\n  font-weight: 600;\n  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.3);\n  animation: pulse-delayed 2s infinite;\n  box-shadow: 0 0 10px rgba(249, 115, 22, 0.3);\n}\n\n@keyframes pulse-countdown {\n  0%, 100% { \n    transform: scale(1);\n  }\n  50% { \n    transform: scale(1.05);\n  }\n}\n\n@keyframes pulse-glow {\n  0%, 100% { \n    box-shadow: 0 0 10px rgba(239, 68, 68, 0.3);\n    transform: scale(1);\n  }\n  50% { \n    box-shadow: 0 0 20px rgba(239, 68, 68, 0.5);\n    transform: scale(1.02);\n  }\n}\n\n@keyframes pulse-delayed {\n  0%, 100% { \n    box-shadow: 0 0 10px rgba(249, 115, 22, 0.3);\n    transform: scale(1);\n  }\n  50% { \n    box-shadow: 0 0 20px rgba(249, 115, 22, 0.5);\n    transform: scale(1.02);\n  }\n}\n\n/* Enhanced Live Dot Animation */\n.live-dot {\n  display: inline-block;\n  width: 8px;\n  height: 8px;\n  background-color: white;\n  border-radius: 50%;\n  margin-right: 6px;\n  animation: pulse-dot 1.5s infinite;\n  box-shadow: 0 0 4px rgba(255, 255, 255, 0.5);\n}\n\n@keyframes pulse-dot {\n  0%, 100% { \n    opacity: 1;\n    transform: scale(1);\n  }\n  50% { \n    opacity: 0.3;\n    transform: scale(0.8);\n  }\n}\n\n/* Delayed Dot Animation */\n.delayed-dot {\n  display: inline-block;\n  width: 8px;\n  height: 8px;\n  background-color: white;\n  border-radius: 50%;\n  margin-right: 6px;\n  animation: pulse-delayed-dot 2s infinite;\n  box-shadow: 0 0 4px rgba(255, 255, 255, 0.5);\n}\n\n@keyframes pulse-delayed-dot {\n  0%, 100% { \n    opacity: 1;\n    transform: scale(1);\n  }\n  50% { \n    opacity: 0.4;\n    transform: scale(0.7);\n  }\n}\n\n/* Traditional Bootstrap Badges - Smaller */\n.game-badge {\n  padding: 4px 8px;\n  font-weight: 500;\n  font-size: 0.75rem;\n  transition: all 0.15s ease;\n  cursor: pointer;\n  text-decoration: none;\n  margin: 2px;\n  border-radius: 4px;\n}\n\n.game-badge:hover {\n  opacity: 0.8;\n  transform: none;\n  box-shadow: none;\n}\n\n/* Traditional Bootstrap Colors */\n.badge.bg-success {\n  background-color: #DC2626 !important; /* Match DataTable live badge red */\n  color: white !important;\n  border: none !important;\n}\n\n.badge.bg-info {\n  background-color: #0dcaf0 !important;\n  color: #000 !important;\n  border: none !important;\n}\n\n.badge.bg-light {\n  background-color: #f8f9fa !important;\n  color: #212529 !important;\n  border: 1px solid #dee2e6 !important;\n}\n\n/* Live badge dot for navigation badges */\n.badge.bg-success .live-dot-nav {\n  display: inline-block;\n  width: 6px;\n  height: 6px;\n  background-color: white;\n  border-radius: 50%;\n  margin-right: 4px;\n  animation: pulse-dot 1.5s infinite;\n  box-shadow: 0 0 3px rgba(255, 255, 255, 0.5);\n}\n\n/* Enhanced Team Logos */\n.team-logo {\n  width: 16px;\n  height: 16px;\n  margin-right: 6px;\n  vertical-align: middle;\n  transition: transform 0.15s ease;\n}\n\n.team-logo:hover {\n  transform: scale(1.2);\n}\n\n/* Enhanced Flash Animation */\n@keyframes flash {\n  0% { \n    background-color: #EF4444;\n    color: white;\n    transform: scale(1.05);\n  }\n  100% { \n    background-color: inherit;\n    color: inherit;\n    transform: scale(1);\n  }\n}\n\n/* Enhanced Last Updated Text */\n.last-updated {\n  font-size: 0.75rem;\n  color: var(--gray-600);\n  margin-top: 2px;\n  font-style: italic;\n  opacity: 0.8;\n}\n\n/* Game Section Headers */\n.game-header {\n  font-family: 'Inter', sans-serif;\n  font-weight: 600;\n  margin-bottom: 1rem;\n  display: flex;\n  align-items: center;\n  padding: 10px 0;\n  border-bottom: 2px solid #E5E7EB;\n}\n\n.game-header img {\n  transition: transform 0.2s ease;\n}\n\n.game-header img:hover {\n  transform: scale(1.1);\n}\n\n/* Table Group Spacing */\n.table-group {\n  margin-bottom: 1rem;\n  margin-left: auto;\n  margin-right: auto;\n  padding: .5rem .25rem .5rem .25rem;\n  background: white;\n  border-radius: 6px; /* Reduced from 12px */\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);\n  /* Expand to fit the widest child (e.g. wide odds tables) so the game\n     header above stays aligned with the table width — but never shrink\n     below the parent width when content is sparse (no data / collapsed). */\n  width: fit-content;\n  min-width: 100%;\n  /* No max-width: card can grow past .container so the per-book 75px floor\n     is honored when there are many books. */\n}\n\n/* Game Header Container */\n.game-header-container {\n  font-family: 'Inter', sans-serif;\n  font-weight: 600;\n  font-size: 1.1rem;\n  margin-bottom: 1rem;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 8px 0;\n  border-bottom: 2px solid #E5E7EB;\n  color: #374151;\n}\n\n.game-header-container img {\n  transition: transform 0.2s ease;\n}\n\n.game-header-container img:hover {\n  transform: scale(1.1);\n}\n\n/* Enhanced Navbar */\n.navbar-dark {\n  background: linear-gradient(135deg, #1F2937 0%, #111827 100%) !important;\n  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);\n  z-index: 1030;\n}\n\n.navbar-brand {\n  font-weight: 700;\n  font-size: 1.5rem;\n  letter-spacing: -0.025em;\n}\n\n/* Container Improvements */\n.container {\n  /* Allow the games container to expand horizontally when many books push\n     odds-table min-width past 1400px. Body will horizontally scroll on\n     narrow viewports — the alternative is squeezing odds columns below\n     readability. */\n  max-width: none;\n}\n\n/* Responsive Improvements */\n@media (max-width: 768px) {\n  .odds-cell {\n    font-size: 0.8rem;\n    padding: 8px 4px;\n  }\n  \n  .team-logo {\n    width: 14px;\n    height: 14px;\n  }\n  \n  .table-container {\n    font-size: 0.875rem;\n  }\n  \n  .game-badge {\n    padding: 6px 12px;\n    font-size: 0.8rem;\n  }\n  \n  .navbar-brand {\n    font-size: 1.25rem;\n  }\n\n  /* Mobile body padding */\n  .container {\n    padding-left: 8px;\n    padding-right: 8px;\n  }\n\n  /* Mobile table width constraints */\n  .table-group {\n    max-width: 100vw;\n    overflow-x: hidden;\n  }\n\n  .table-container table {\n    table-layout: fixed;\n    width: 100%;\n  }\n\n  /* Mobile player name column - increased from 25% to 35% */\n  .player-name-cell,\n  .player-name-cell-no-logo {\n    max-width: 140px;\n    min-width: 140px;\n    width: 140px;\n    font-size: 0.8rem;\n  }\n\n  /* Mobile odds columns - reduced width to accommodate larger name column */\n  .odds-cell {\n    width: 15%;\n    min-width: 42px;\n    padding: 6px 1px;\n    font-size: 0.75rem;\n  }\n}\n\n/* Smooth Scrolling */\nhtml {\n  scroll-behavior: smooth;\n}\n\n/* Focus States for Accessibility */\n.game-badge:focus,\n.odds-cell:focus {\n  outline: 2px solid #3B82F6;\n  outline-offset: 2px;\n}\n\n/* Footer Styling */\n.app-footer {\n  margin-top: 3rem;\n  padding: 2rem 0;\n  border-top: 1px solid #E5E7EB;\n  text-align: center;\n}\n\n.footer-content {\n  font-size: 0.875rem;\n  color: var(--gray-600);\n  opacity: 0.8;\n  line-height: 1.5;\n}\n\n/* Final Game Message */\n.final-game-message {\n  text-align: center;\n  padding: 3rem 2rem;\n  color: var(--gray-600);\n}\n\n.final-game-message h4 {\n  margin-bottom: 0.5rem;\n  color: var(--gray-900);\n  font-weight: 600;\n}\n\n.final-game-message p {\n  margin: 0;\n  font-size: 0.95rem;\n  opacity: 0.8;\n}\n\n/* Skeleton Loading Animations */\n.skeleton-text {\n  height: 16px;\n  background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);\n  background-size: 200% 100%;\n  animation: skeleton-loading 1.5s infinite;\n  border-radius: 4px;\n  width: 80%;\n}\n\n.skeleton-odds {\n  height: 14px;\n  background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);\n  background-size: 200% 100%;\n  animation: skeleton-loading 1.5s infinite;\n  border-radius: 4px;\n  width: 60%;\n  margin: 0 auto;\n}\n\n@keyframes skeleton-loading {\n  0% { background-position: 200% 0; }\n  100% { background-position: -200% 0; }\n}\n\n/* Player Modal Styles */\n/* Ensure player modals render above mobile trends overlay (z-index: 1100) */\n.player-modal-backdrop {\n  z-index: 1199 !important;\n}\n.player-modal,\n.nba-player-modal,\n.nfl-player-modal,\n.nhl-player-modal,\n.soccer-player-modal {\n  z-index: 1200 !important;\n}\n\n.player-modal .modal-dialog {\n  max-width: 900px !important;\n  width: 900px !important;\n  margin: 1rem auto;\n}\n\n/* NFL Player Modal Styles */\n.nfl-player-modal .modal-dialog {\n  max-width: 900px !important;\n  width: 900px !important;\n  margin: 1rem auto;\n}\n\n.player-modal .modal-content {\n  border: none;\n  border-radius: 12px;\n  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3);\n  backdrop-filter: blur(10px);\n}\n\n.player-modal .modal-header {\n  border-bottom: 2px solid rgba(255, 255, 255, 0.1);\n  padding: 1.5rem 2rem;\n}\n\n/* .player-modal close-button styling now lives in the unified rule below\n   with the other player modals — see .*-player-modal .btn-close. */\n\n.player-modal .modal-body {\n  padding: 2rem;\n  background: #f8f9fa;\n}\n\n.player-modal .modal-footer {\n  border-top: 1px solid #e9ecef;\n  padding: 1rem 2rem;\n}\n\n/* Chart container styling */\n.player-modal canvas {\n  border-radius: 8px;\n  background: white;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);\n}\n\n/* Summary cards styling */\n.player-modal .card {\n  border: none;\n  border-radius: 8px;\n  transition: transform 0.2s ease;\n}\n\n.player-modal .card:hover {\n  transform: translateY(-2px);\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);\n}\n\n/* Table styling within modal */\n.player-modal .table-responsive {\n  border-radius: 8px;\n  border: 1px solid #e9ecef;\n}\n\n.player-modal .table {\n  margin-bottom: 0;\n}\n\n.player-modal .table-dark {\n  background-color: #495057;\n}\n\n/* Consistent bookmaker column widths */\n.player-modal .table th:not(:first-child),\n.player-modal .table td:not(:first-child),\n.nfl-player-modal .table th:not(:first-child),\n.nfl-player-modal .table td:not(:first-child) {\n  min-width: 70px;\n}\n\n/* Mobile responsiveness for modal */\n@media (max-width: 768px) {\n  .player-modal .modal-dialog,\n  .nhl-player-modal .modal-dialog,\n  .nfl-player-modal .modal-dialog {\n    max-width: 100vw !important;\n    width: 100vw !important;\n    margin: 0;\n    height: 100vh;\n  }\n  \n  .player-modal .modal-content,\n  .nhl-player-modal .modal-content,\n  .nfl-player-modal .modal-content {\n    height: 100vh;\n    border-radius: 0;\n    /* Explicit flex column + hidden overflow makes the child modal-body the\n       only scroll container; without this the whole modal scrolls as one\n       and the header rides the body up. Bootstrap sets flex on .modal-content\n       by default but iOS Safari plus fullscreen sometimes drops it. */\n    display: flex;\n    flex-direction: column;\n    overflow: hidden;\n  }\n\n  .player-modal .modal-header,\n  .nhl-player-modal .modal-header,\n  .nfl-player-modal .modal-header {\n    padding: 1rem;\n    /* Pin the header — never shrink and never scroll off. */\n    flex: 0 0 auto;\n  }\n\n  .player-modal .modal-body,\n  .nhl-player-modal .modal-body,\n  .nfl-player-modal .modal-body {\n    padding: 1rem;\n    flex: 1 1 auto;\n    /* `min-height: 0` is the classic flexbox trick that lets a flex child\n       shrink below its content size so overflow scrolls inside it instead\n       of pushing the parent (and header) upward. */\n    min-height: 0;\n    overflow-y: auto;\n    -webkit-overflow-scrolling: touch;\n  }\n\n  .player-modal .modal-footer,\n  .nhl-player-modal .modal-footer,\n  .nfl-player-modal .modal-footer {\n    padding: 1rem;\n  }\n}\n\n/* Dark mode team logo adjustments */\n.dark-mode .team-logo {\n  /* No filter needed - using proper white logos */\n}\n\n.dark-mode .best-bets-team-logo,\n.dark-mode .best-bets-team-logo-small {\n  /* No filter needed - using proper white logos */\n}\n\n/* Player Modal Takeover Styles */\n.player-modal-takeover {\n  position: fixed;\n  top: 56px;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  width: 100vw;\n  height: calc(100vh - 56px);\n  background: white;\n  z-index: 1040;\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n  transform: translateY(100%);\n  transition: transform 0.3s ease;\n}\n\n.player-modal-takeover.show {\n  transform: translateY(0);\n}\n\n.player-modal-takeover-header {\n  background: linear-gradient(135deg, #0d6efd 0%, #0a58ca 100%);\n  color: white;\n  padding: 1rem;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);\n}\n\n.player-modal-takeover-body {\n  flex: 1;\n  overflow-y: auto;\n  background: #f8f9fa;\n  padding: 1rem;\n}\n\n/* Dark mode player modal takeover */\n.dark-mode .player-modal-takeover {\n  background: #1f2937;\n}\n\n.dark-mode .player-modal-takeover-header {\n  background: linear-gradient(135deg, #1e40af 0%, #1e3a8a 100%);\n  border-bottom: 1px solid #374151;\n}\n\n.dark-mode .player-modal-takeover-body {\n  background: #111827;\n  color: #e5e7eb;\n}\n\n/* Settings Takeover Styles */\n.settings-takeover {\n  position: fixed;\n  top: 56px;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  width: 100vw;\n  height: calc(100vh - 56px);\n  background: white;\n  z-index: 2000;\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n}\n\n/* Desktop: max 50% width, centered */\n@media (min-width: 769px) {\n  .settings-takeover {\n    left: 50%;\n    transform: translateX(-50%);\n    max-width: 50vw;\n    width: 50vw;\n    border-left: 1px solid #e5e7eb;\n    border-right: 1px solid #e5e7eb;\n  }\n\n  .dark-mode .settings-takeover {\n    border-left-color: #374151;\n    border-right-color: #374151;\n  }\n}\n\n.settings-takeover-header {\n  background: linear-gradient(135deg, #374151 0%, #1f2937 100%);\n  color: white;\n  padding: 1rem;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);\n}\n\n.settings-takeover-body {\n  flex: 1;\n  overflow-y: auto;\n  background: #f3f4f6;\n  padding: 1.5rem 0;\n}\n\n.settings-section {\n  margin-bottom: 2rem;\n  padding: 0 3px;\n}\n\n.settings-section-title {\n  font-size: 0.875rem;\n  font-weight: 600;\n  color: #6b7280;\n  text-transform: uppercase;\n  letter-spacing: 0.05em;\n  margin-bottom: 1rem;\n  border-bottom: 1px solid #e5e7eb;\n  padding-bottom: 0.5rem;\n}\n\n.setting-item {\n  background: white;\n  border-radius: 8px;\n  padding: 1rem;\n  margin-bottom: 0.75rem;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);\n}\n\n.setting-label {\n  font-weight: 500;\n  color: #1f2937;\n  margin-bottom: 0.25rem;\n}\n\n.setting-description {\n  font-size: 0.875rem;\n  line-height: 1.4;\n}\n\n.setting-value {\n  font-size: 0.875rem;\n}\n\n.setting-switch {\n  transform: scale(1.2);\n}\n\n/* Dark mode settings takeover */\n.dark-mode .settings-takeover {\n  background: #1f2937;\n}\n\n.dark-mode .settings-takeover-header {\n  background: linear-gradient(135deg, #111827 0%, #000000 100%);\n  border-bottom: 1px solid #374151;\n}\n\n.dark-mode .settings-takeover-body {\n  background: #111827;\n  color: #e5e7eb;\n}\n\n.dark-mode .settings-section-title {\n  color: #9ca3af;\n  border-bottom-color: #374151;\n}\n\n/* Desktop: Settings as a panel like Best Bets (overrides default takeover) */\n@media (min-width: 769px) {\n  .settings-takeover.desktop-panel {\n    top: 130px;\n    left: 5px;\n    right: 5px;\n    bottom: 5px;\n    transform: none;\n    width: auto;\n    max-width: none;\n    height: auto;\n    background: #212529;\n    border: none;\n    border-radius: 12px;\n    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.4);\n    overflow: hidden;\n    z-index: 2000;\n  }\n\n  .settings-takeover.desktop-panel .settings-takeover-header {\n    background: #212529;\n    border-bottom: 1px solid #333;\n    padding: 8px 12px;\n    box-shadow: none;\n  }\n\n  .settings-takeover.desktop-panel .settings-takeover-header h5 {\n    font-family: 'Oswald', sans-serif;\n    font-size: 1rem;\n    font-weight: 600;\n    letter-spacing: 0.04em;\n    text-transform: uppercase;\n  }\n\n  .settings-takeover.desktop-panel .settings-takeover-body {\n    background: #1a1d21;\n    padding: 16px 20px;\n    color: #e5e7eb;\n  }\n\n  .settings-takeover.desktop-panel .settings-takeover-body-grid {\n    display: grid;\n    grid-template-columns: 1fr 1fr 1fr;\n    column-gap: 24px;\n    row-gap: 4px;\n    align-items: start;\n  }\n\n  .settings-takeover.desktop-panel .settings-takeover-body-grid > [data-col=\"1\"] {\n    grid-column: 1;\n  }\n  .settings-takeover.desktop-panel .settings-takeover-body-grid > [data-col=\"2\"] {\n    grid-column: 2;\n  }\n  .settings-takeover.desktop-panel .settings-takeover-body-grid > [data-col=\"3\"] {\n    grid-column: 3;\n  }\n\n  .settings-takeover.desktop-panel .settings-section {\n    margin-bottom: 16px;\n    padding: 0;\n  }\n\n  .settings-takeover.desktop-panel .settings-section-title {\n    color: #e5e7eb;\n    border-bottom-color: #333;\n    margin-bottom: 12px;\n  }\n\n  .settings-takeover.desktop-panel .setting-item {\n    background: #2a2d31;\n    color: #e5e7eb;\n    box-shadow: none;\n    border: 1px solid #333;\n  }\n\n  .settings-takeover.desktop-panel .setting-label {\n    color: #e5e7eb;\n  }\n}\n\n.dark-mode .setting-item {\n  background: #1f2937;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.3);\n}\n\n.dark-mode .setting-label {\n  color: #e5e7eb;\n}\n\n.dark-mode .setting-description {\n  color: #9ca3af;\n}\n\n.dark-mode .setting-value {\n  color: #9ca3af;\n}\n\n/* Books grid in settings */\n.books-grid {\n  display: flex;\n  flex-direction: column;\n  gap: 0.5rem;\n  max-width: 400px;\n}\n\n@media (max-width: 768px) {\n  .books-grid {\n    max-width: 100%;\n  }\n}\n\n.books-secondary-divider {\n  margin: 0.75rem 0 0.5rem;\n  padding: 0.5rem 0.75rem;\n  border-top: 1px solid #cbd5e1;\n  background: transparent;\n}\n\n.books-secondary-divider-label {\n  font-size: 0.7rem;\n  font-weight: 700;\n  text-transform: uppercase;\n  letter-spacing: 0.06em;\n  color: #475569;\n  margin-bottom: 0.25rem;\n}\n\n.books-secondary-divider-blurb {\n  display: block;\n  font-size: 0.72rem;\n  line-height: 1.35;\n  color: #64748b;\n}\n\n.dark-mode .books-secondary-divider,\n.settings-takeover.desktop-panel .books-secondary-divider {\n  border-top-color: #3f4651;\n}\n\n.dark-mode .books-secondary-divider-label,\n.settings-takeover.desktop-panel .books-secondary-divider-label {\n  color: #cbd5e1;\n}\n\n.dark-mode .books-secondary-divider-blurb,\n.settings-takeover.desktop-panel .books-secondary-divider-blurb {\n  color: #94a3b8;\n}\n\n.book-toggle-item {\n  background: #f8f9fa;\n  border-radius: 6px;\n  padding: 0.75rem;\n  border: 1px solid #e9ecef;\n  cursor: grab;\n  user-select: none;\n  transition: all 0.2s ease;\n  position: relative;\n}\n\n.book-toggle-item:hover {\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);\n  transform: translateY(-1px);\n}\n\n.book-toggle-item.dragging {\n  opacity: 0.5;\n  transform: rotate(5deg);\n  cursor: grabbing;\n}\n\n.book-toggle-item.drag-over {\n  border-color: #007bff;\n  background-color: rgba(0, 123, 255, 0.1);\n}\n\n.drag-handle {\n  color: #6c757d;\n  margin-right: 8px;\n  font-size: 14px;\n  cursor: grab;\n  padding: 2px;\n}\n\n.drag-handle:hover {\n  color: #495057;\n}\n\n.book-name {\n  font-size: 0.875rem;\n  font-weight: 500;\n}\n\n.book-switch {\n  transform: scale(0.9);\n  pointer-events: auto;\n}\n\n/* Dark mode books grid */\n.dark-mode .book-toggle-item {\n  background: #374151;\n  border-color: #4b5563;\n}\n\n.dark-mode .book-toggle-item:hover {\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.3);\n}\n\n.dark-mode .book-toggle-item.drag-over {\n  border-color: #3b82f6;\n  background-color: rgba(59, 130, 246, 0.1);\n}\n\n.dark-mode .book-name {\n  color: #e5e7eb;\n}\n\n.dark-mode .drag-handle {\n  color: #9ca3af;\n}\n\n.dark-mode .drag-handle:hover {\n  color: #d1d5db;\n}\n\n/* Custom legend layout for mobile chart */\n@media (max-width: 768px) {\n  .player-modal-takeover .chartjs-legend {\n    display: flex !important;\n    flex-wrap: wrap !important;\n    justify-content: center !important;\n    gap: 8px !important;\n  }\n  \n  .player-modal-takeover .chartjs-legend ul {\n    display: flex !important;\n    flex-wrap: wrap !important;\n    justify-content: center !important;\n    gap: 8px !important;\n    width: 100% !important;\n    padding: 0 !important;\n    margin: 0 !important;\n  }\n  \n  .player-modal-takeover .chartjs-legend li {\n    flex: 0 0 calc(33.33% - 8px) !important;\n    text-align: center !important;\n    margin: 0 !important;\n    padding: 4px !important;\n    display: flex !important;\n    align-items: center !important;\n    justify-content: center !important;\n    font-size: 10px !important;\n  }\n}\n\n/* Mobile touch drag styling */\n@media (max-width: 768px) {\n  .book-toggle-item {\n    touch-action: manipulation;\n  }\n\n  .book-toggle-item:active {\n    transform: scale(0.98);\n    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);\n  }\n}\n\n/* Authentication blur effect for odds */\n.odds-blur {\n  filter: blur(5px);\n  user-select: none;\n  pointer-events: none;\n  transition: filter 0.3s ease;\n}\n\n.odds-blur:hover {\n  filter: blur(5px);\n}\n\n/* Mobile checkout modal - remove all margins */\n@media (max-width: 768px) {\n  .checkout-modal-mobile {\n    margin: 0 !important;\n  }\n\n  .checkout-modal-mobile .modal-content {\n    margin: 0 !important;\n    padding: 0 !important;\n    border-radius: 0 !important;\n  }\n\n  .checkout-modal-mobile .modal-body {\n    padding: 0 !important;\n  }\n}\n\n/* Spinner animation for checkout status */\n@keyframes spin {\n  from {\n    transform: rotate(0deg);\n  }\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n/* Betslip add animation */\n@keyframes betAddPulse {\n  0% {\n    background-color: rgba(255, 193, 7, 0.3);\n    transform: scale(1);\n  }\n  50% {\n    background-color: rgba(255, 193, 7, 0.6);\n    transform: scale(1.05);\n  }\n  100% {\n    background-color: transparent;\n    transform: scale(1);\n  }\n}\n\n.bet-add-animation {\n  animation: betAddPulse 0.5s ease-out;\n}\n\n/* Betslip button bounce */\n@keyframes buttonBounce {\n  0%, 100% {\n    transform: scale(1);\n  }\n  25% {\n    transform: scale(1.15);\n  }\n  50% {\n    transform: scale(1.05);\n  }\n  75% {\n    transform: scale(1.1);\n  }\n}\n\n.betslip-button-bounce {\n  animation: buttonBounce 0.5s ease-out;\n}\n\n/* Toast slide in animation */\n@keyframes slideInRight {\n  from {\n    transform: translateX(400px);\n    opacity: 0;\n  }\n  to {\n    transform: translateX(0);\n    opacity: 1;\n  }\n}\n\n/* Bottom-center toast: fade + slight rise. Purely opacity/translateY so it\n   composes with a fixed translateX(-50%) horizontal centering. */\n@keyframes toastFadeUp {\n  from {\n    opacity: 0;\n    transform: translateX(-50%) translateY(8px);\n  }\n  to {\n    opacity: 1;\n    transform: translateX(-50%) translateY(0);\n  }\n}\n\n/* All mobile player modals — enlarge the top-right close X so it's an easy\n   tap target on mobile, and shift the default black glyph to a medium grey\n   so it reads as a control without punching a hard black hole against the\n   near-white header. Hover deepens the grey and adds a subtle circular wash.\n   Consistent across NFL, NHL, NBA/WNBA, MLB/NCAAB, and Soccer modals. */\n.nfl-player-modal .modal-header .btn-close,\n.nhl-player-modal .modal-header .btn-close,\n.nba-player-modal .modal-header .btn-close,\n.player-modal .modal-header .btn-close,\n.soccer-player-modal .modal-header .btn-close {\n  width: 1.75rem;\n  height: 1.75rem;\n  padding: 0.75rem;\n  background-size: 1.25rem;\n  opacity: 1;\n  border-radius: 50%;\n  filter: invert(45%) sepia(6%) saturate(0%) brightness(95%);\n  transition: filter 0.15s ease, background-color 0.15s ease;\n}\n.nfl-player-modal .modal-header .btn-close:hover,\n.nfl-player-modal .modal-header .btn-close:focus,\n.nhl-player-modal .modal-header .btn-close:hover,\n.nhl-player-modal .modal-header .btn-close:focus,\n.nba-player-modal .modal-header .btn-close:hover,\n.nba-player-modal .modal-header .btn-close:focus,\n.player-modal .modal-header .btn-close:hover,\n.player-modal .modal-header .btn-close:focus,\n.soccer-player-modal .modal-header .btn-close:hover,\n.soccer-player-modal .modal-header .btn-close:focus {\n  filter: invert(25%) sepia(6%) saturate(0%) brightness(95%);\n  background-color: rgba(0, 0, 0, 0.06);\n  box-shadow: none;\n}\n\n/* Announcements button pulse animation */\n@keyframes pulse-announcement {\n  0%, 100% {\n    box-shadow: 0 0 12px rgba(251, 191, 36, 0.5), 0 2px 8px rgba(0, 0, 0, 0.3);\n  }\n  50% {\n    box-shadow: 0 0 20px rgba(251, 191, 36, 0.8), 0 2px 8px rgba(0, 0, 0, 0.3);\n  }\n}\n\n/* Announcements dot pulse animation */\n@keyframes pulse-dot {\n  0%, 100% {\n    transform: scale(1);\n    opacity: 1;\n  }\n  50% {\n    transform: scale(1.3);\n    opacity: 0.7;\n  }\n}\n/* Dark scrollbar styling for panels and modals */\n.dark-scrollbar::-webkit-scrollbar,\n.dark-panel ::-webkit-scrollbar,\n.dark-panel::-webkit-scrollbar {\n  height: 6px;\n  width: 6px;\n}\n\n.dark-scrollbar::-webkit-scrollbar-track,\n.dark-panel ::-webkit-scrollbar-track,\n.dark-panel::-webkit-scrollbar-track {\n  background: #111;\n  border-radius: 3px;\n}\n\n.dark-scrollbar::-webkit-scrollbar-thumb,\n.dark-panel ::-webkit-scrollbar-thumb,\n.dark-panel::-webkit-scrollbar-thumb {\n  background: #333;\n  border-radius: 3px;\n}\n\n.dark-scrollbar::-webkit-scrollbar-thumb:hover,\n.dark-panel ::-webkit-scrollbar-thumb:hover,\n.dark-panel::-webkit-scrollbar-thumb:hover {\n  background: #444;\n}\n\n/* Circled-icon buttons (Leaders, Neg Corr).\n   Desktop variant: the chip ships with a solid warning-yellow background\n   and `color:#000` inline, so the pill is always visible on the dark page.\n   On hover Bootstrap fills the whole button yellow, so we flip the chip's\n   border to black to keep the pill shape visible against the matching\n   yellow surface.\n   Mobile variant: the chip ships with no inline background and no color\n   override, so the pill reads as just a yellow outline with a yellow icon\n   (inherited `currentColor`). On tap (`:active`) the chip fills warning\n   yellow and the icon switches to black, giving a clear press response.\n   The same rule covers desktop `:active` without changing the already-\n   yellow pill. */\n.circled-icon-btn:hover .circled-icon-chip {\n  border-color: #000 !important;\n}\n.circled-icon-btn:active .circled-icon-chip,\n.circled-icon-btn.active .circled-icon-chip {\n  background-color: #ffc107 !important;\n  color: #000 !important;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
